import {Color} from '@vivli/shared/theme';
import {CSSProperties, useState} from 'react';
import {ArrowContainer, Popover} from 'react-tiny-popover';

const popoverStyle: CSSProperties = {
    backgroundColor: Color.TEXT_LIGHT_BLUE,
    color: 'white',
    maxWidth: '400px',
    padding: '0.7em',
    borderRadius: '0.5em',
};

export const HelpTextView = ({value, scrollable = true, children}: any) => {
    const [isOpen, setIsOpen] = useState(false);

    const containerStyle: CSSProperties = {
        height: '100%',
        overflowX: 'hidden',
        overflowY: scrollable ? 'auto' : 'hidden',
        wordBreak: 'break-word',
        whiteSpace: 'normal',
        lineHeight: '18px',
    };

    return (
        <Popover
            isOpen={isOpen}
            content={(props) => (
                <ArrowContainer {...props} arrowSize={8} arrowColor={Color.TEXT_LIGHT_BLUE}>
                    <div style={popoverStyle}>{value}</div>
                </ArrowContainer>
            )}
        >
            <div style={containerStyle} onMouseEnter={() => value && setIsOpen(true)} onMouseLeave={() => value && setIsOpen(false)}>
                {children}
            </div>
        </Popover>
    );
};
